import React from 'react';
import { Dropdown } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import { ActivityColor } from '../../../../types';
import { getActivityColors } from '../../../../utils/color';
import styles from '../RegionNoteForm.css';

type RegionNoteFormColorProps = {
  color: ActivityColor;
  setColor: (ActivityColor) => void;
};

export const RegionNoteFormColor = ({ color, setColor}: RegionNoteFormColorProps) => (
  <Dropdown
    className={styles.regionColorDropdown}
    data-test-id="region-note-form-dropdown-colors"
    label={
      <div className={styles.regionColorDropdownLabel}>
        {getMessage('scouting.form.color')}
        <div
          className={styles.regionColorDropdownPreview}
          style={{ backgroundColor: color }}
        />
      </div>
    }
    options={getActivityColors()}
    selectedId={color}
    setValue={(_value, id: ActivityColor) => setColor(id)}
  />
);
